import React from "react";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { DOCUMENT_MODE } from "../../redux/constants/metaData";
import { useTheme } from "../../theme/OAS365Theme";
import { formatNumberAndRevision } from "../../utils/formatNumberAndRevision";
import { TruncatedTextWithTooltip } from "../common/TruncatedTextWithTooltip";
import { formatIfsDocumentLastActionDisplay } from "../../functions/dateFormater";

const labelCellStyle = {
  width: "180px",
  maxWidth: "180px",
  fontWeight: "bold",
  paddingRight: "10px",
  verticalAlign: "top",
};

const valueCellStyle = {
  wordBreak: "break-word",
  overflowWrap: "anywhere",
  verticalAlign: "top",
  minWidth: 0,
};

const titleValueCellStyle = {
  verticalAlign: "top",
  minWidth: 0,
  maxWidth: "100%",
};

function normalizeCheckStateText(text) {
  if (!text) return "-";
  return String(text)
    .replace(/\bChecked In\b/g, "Checked-in")
    .replace(/\bChecked Out\b/g, "Checked-out")
    .replace(/\bUndo Check Out\b/g, "Undo Check-out");
}

export default function DocumentDetailsContent({
  workingIfsDocument,
  documentMode,
}) {
  const theme = useTheme();

  if (documentMode !== DOCUMENT_MODE.ifs || !workingIfsDocument) {
    return <div>No details available</div>;
  }

  const hasFormatValue =
    workingIfsDocument.FormatSize !== null &&
    workingIfsDocument.FormatSize !== undefined &&
    workingIfsDocument.FormatSize !== "" &&
    workingIfsDocument.FormatSize !== "-";

  return (
    <DialogContent
      sx={{ overflowX: "hidden", maxWidth: "100%", boxSizing: "border-box", paddingTop: "5px" }}
    >
      <DialogContentText
        id="all-documents-details-description"
        component="div"
        sx={{ maxWidth: "100%", width: "100%", boxSizing: "border-box" }}
      >
        <div style={{ minWidth: 0, maxWidth: "100%" }}>
          <table
            style={{
              borderSpacing: "0 8px",
              borderCollapse: "separate",
              color: theme.colors.fontColor,
              fontFamily: theme.fonts.regular,
              fontSize: theme.fontSizes.normal,
              width: "100%",
              maxWidth: "100%",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td valign="top" style={labelCellStyle}>
                  Title:
                </td>
                <td valign="top" style={titleValueCellStyle}>
                  <TruncatedTextWithTooltip text={workingIfsDocument.Title} />
                </td>
              </tr>
              <tr>
                <td valign="top" style={labelCellStyle}>
                  Document No:
                </td>
                <td valign="top" style={valueCellStyle}>
                  {formatNumberAndRevision(workingIfsDocument.docNo, workingIfsDocument.docRev)}
                </td>
              </tr>
              <tr>
                <td valign="top" style={labelCellStyle}>
                  Owner:
                </td>
                <td valign="top" style={valueCellStyle}>
                  {workingIfsDocument.DocRespName}
                </td>
              </tr>
              <tr>
                <td valign="top" style={labelCellStyle}>
                  Class:
                </td>
                <td valign="top" style={valueCellStyle}>
                  {`${workingIfsDocument.docClass} - ${workingIfsDocument.DocClassName}`}
                </td>
              </tr>
              <tr>
                <td valign="top" style={labelCellStyle}>
                  Format:
                </td>
                <td valign="top" style={valueCellStyle}>
                  {hasFormatValue
                    ? `${workingIfsDocument.FormatSize} - ${workingIfsDocument.FormatSizeName}`
                    : "-"}
                </td>
              </tr>
              <tr>
                <td valign="top" style={labelCellStyle}>
                  State:
                </td>
                <td valign="top" style={valueCellStyle}>
                  {workingIfsDocument.State}
                </td>
              </tr>
              <tr>
                <td valign="top" style={labelCellStyle}>
                  File Status:
                </td>
                <td valign="top" style={valueCellStyle}>
                  {normalizeCheckStateText(workingIfsDocument.FileState)}
                </td>
              </tr>
              <tr>
                <td valign="top" style={labelCellStyle}>
                  Modified:
                </td>
                <td valign="top" style={valueCellStyle}>
                  {normalizeCheckStateText(
                    formatIfsDocumentLastActionDisplay(workingIfsDocument.LastAction),
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </DialogContentText>
    </DialogContent>
  );
}
